import { WebRtcCommunicationEnvironmentConfig } from "./environment-config";

export const DEFAULT_ENVIRONMENT: WebRtcCommunicationEnvironmentConfig = {
  production: false,
  debug: false,
  beHost: 'https://streaming.digitalmens.dev',
  websocketHost: 'streaming.digitalmens.dev',
  websocketUrl: 'wss://streaming.digitalmens.dev',
  isStatsEnabled: false,
  rtcConfig: {
    sdpSemantics: 'unified-plan',
    iceServers: [
      {
        urls: 'turn:turn.digitalemens.dev:3478',
        username: 'turn_digital',
        credential: 'Digital_2024!'
      },
      {
        urls: 'stun:stun.l.google.com:19302'
      }
    ]
  },
  googleApiKey: 'AIzaSyA3vPM8J5lf1EcEZqRyM6GX-1xE8hcIaIc',
  isTranslateEnabled: true,
  saveScreenshotOnServer: true,
  saveLocallyScreenshot: true,
  isRecordingVisible: true
};